'use strict';
require('./CompanyFlowVerifiesService.js');

CompanyFlowVerifyDetailCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$translate',
  'CompanyUserService',
  'CompanyFlowVerifiesService',
  'flowVerifies',
  'flowVerify',
  'growl'];
function CompanyFlowVerifyDetailCtrl(
  $scope,
  $stateParams,
  $state,
  $translate,
  CompanyUserService,
  CompanyFlowVerifiesService,
  flowVerifies,
  flowVerify,
  growl) {

    var nonWatchersPromise;
    $scope.nonWatchers = [];
    $scope.flowVerify = flowVerify;
    $scope.flowVerifies = flowVerifies;

    $scope.updateNonWatchers = function(filter) {
      var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
        return users.filter(function(item) {
          return !$scope.flowVerify.watchers.some(function(watcher) {
            return item.id === watcher.id;
          });
        });
      }).then(function(nonWatchers) {
        if(nonWatchersPromise === p) {
          $scope.nonWatchers = nonWatchers;
        }
      });
      nonWatchersPromise = p;
    };

    $scope.addWatcher = function(watcher) {
      $scope.flowVerify.watchers.push(watcher);
      angular.element('#filterWatchers').val('');
      $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
    };

    $scope.deleteWatcher = function(watcher) {
      $scope.flowVerify.watchers.splice($scope.flowVerify.watchers.indexOf(watcher), 1);
    };

    $scope.updateFlowVerify = function() {
      CompanyFlowVerifiesService.update({companyId: $stateParams.companyId, flowVerifyID: $scope.flowVerify.id}, $scope.flowVerify, function(){
        growl.addSuccessMessage($translate.instant('flow.update-flow-success'));
      }, function(){
        growl.addErrorMessage($translate.instant('flow.update-flow-failure'));
      });
    };
}

CompanyFlowVerifyDetailCtrl.resolve = {
  flowVerify: ['$stateParams', 'CompanyFlowVerifiesService', function($stateParams, CompanyFlowVerifiesService) {
    return CompanyFlowVerifiesService.get({
      companyId: $stateParams.companyId,
      flowVerifyID: $stateParams.flowVerifyID
    }).$promise;
  }],
  flowVerifies: ['$stateParams', 'CompanyFlowVerifiesService', function($stateParams, CompanyFlowVerifiesService) {
    return CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise;
  }]
};

module.exports = CompanyFlowVerifyDetailCtrl;

angular.module('dokiv')
  .controller('CompanyFlowVerifyDetailCtrl', CompanyFlowVerifyDetailCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/account/CompanyFlowVerifyDetailCtrl.js
// module id = 319
// module chunks = 0